{
	"invalidFileFormat": "Formato de archivo no válido, formatos válidos: {{formats}}",
	"multipleFilesUploaded": "Múltiples archivos enviados",
	"remove": "Eliminar"
}
